<template>
  <div class="overflow-hidden w-ful h-full">
    <component :is="ComponentMenuOptional" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableListKapalCurrentWPP from './TableListKapalCurrentWPP.vue'
import Blank from './Blank.vue'

export default {
  name: 'MenuOptional',
  computed: {
    ...mapGetters(['activeSubMenu']),
    ComponentMenuOptional: function () {
      if (this.activeSubMenu === 'ListKapalCurrentWPP') return TableListKapalCurrentWPP

      return Blank
    }
  }
}
</script>
